var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-sticky-deal-inner vue-variant" }, [
    _c("div", { staticClass: "booking-card" }, [
      _c("div", { staticClass: "price-summary" }, [
        _c("span", {
          staticClass: "price",
          domProps: { innerHTML: _vm._s(_vm.priceString) },
        }),
        _vm._v(" "),
        _vm.caption
          ? _c("div", { staticClass: "booking-info" }, [
              _vm._v("\n        " + _vm._s(_vm.caption) + "\n      "),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "booking-submit",
          class: { "sold-out": !_vm.isForSale },
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("submit")
            },
          },
        },
        [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }